import { Grid } from "@mui/material";
import React from "react";
import TotalRevenueHeader from "./home/header";
import TotalRevenueTabel from "./home/table";

const TotalRevenue = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TotalRevenueHeader />
      </Grid>
      <Grid item xs={12}>
        <TotalRevenueTabel />
      </Grid>
    </Grid>
  );
};

export default TotalRevenue;
